import { computed, ComputedRef } from 'vue';
import { Field, FieldType } from '@/domain/models/Field';
import { Trans, trans } from '@/domain/dao/Translations';

type Props = {
	field: Field & {
		title: string | null;
		labelMarkdown?: string | null;
		label: string | null;
	};
	isManager: boolean;
	for: string | null;
	elementId: string;
};

type View = {
	lang: Trans;
	fieldId: ComputedRef<string>;
	showFieldAccess: ComputedRef<boolean>;
	label: ComputedRef<string | null>;
	isAIField: ComputedRef<boolean>;
};

const fieldLabelController = (props: Props): View => {
	const lang = trans();

	const fieldId = computed(() => String(props.for ? props.for : `${props.field.slug}-${props.elementId}`));

	const showFieldAccess = computed(() => props.field.resource !== 'Users');

	const isAIField = computed(() => props.field.type === FieldType.AIAGENT);

	const isOptional = computed(
		() =>
			!props.field.required &&
			!['content', 'formula'].includes(props.field.type) &&
			((props.field.entrantReadAccess && props.field.entrantWriteAccess) || props.field.resource === 'Users')
	);

	const appendOptionalText = (text: string, optionalText: string): string => {
		const parts = text.split(/(\r\n|\n|\r|<br>|<br \/>|<\/p>)/);
		const firstLine = parts[0].trim();
		const remainingText = parts.slice(1).join('');

		if (firstLine.startsWith('<p')) {
			return `${firstLine}${optionalText}${remainingText}`;
		} else if (firstLine.startsWith('<ul') || firstLine.startsWith('<ol')) {
			return text.replace(
				/<li([^>]*)>(.*?)<\/li>/,
				(match, attrs, content) => `<li${attrs}>${content}${optionalText}</li>`
			);
		} else {
			return `${firstLine}${optionalText}${remainingText}`;
		}
	};

	const label = computed(() => {
		const text = props.field.labelMarkdown ? props.field.labelMarkdown : props.field.title;

		if (!text) return null;

		if (isOptional.value) {
			return appendOptionalText(text, lang.get('miscellaneous.optional'));
		}

		return text;
	});

	return {
		lang,
		fieldId,
		label,
		showFieldAccess,
		isAIField,
	};
};

export { fieldLabelController, Props, View };
